import React from 'react'
import { Icon } from '../Icon'

interface UICheckboxProps {
  label: string
  checked: boolean
  onChange: () => void
}

const UICheckbox: React.FC<UICheckboxProps> = ({
  label,
  checked = false,
  onChange,
}) => {
  return (
    <label className="inline-flex items-center space-x-2 cursor-pointer">
      {/* Render the checkbox */}
      <div onClick={onChange}>
        {checked ? (
          <Icon
            name={'IconFillCheckbox'}
            width={16}
            height={16}
            strokeWidth={1}
          />
        ) : (
          <div className="w-[16px] h-[16px] rounded-[4px] border border-gray3 bg-transparent"></div>
        )}
      </div>
      <span className="text-sm text-text1 font-normal">{label}</span>
    </label>
  )
}

export default UICheckbox
